<template>
  <div class="event">
    <div class="event__image">
      <Lightbox
        v-if="image"
        :thumb="thumbnail"
        :src="image"
      />
      <div v-if="!image" class="event__image-placeholder"></div>
    </div>
    <div class="event__main">
      <h2 class="event__title">{{ title }}</h2>
      <p class="event__location">{{ location }}</p>
      <div class="event__times">
        <p class="event__date">{{ _start.format('dddd Do MMMM YYYY') }}</p>
        <p class="event__time">
          <span class="event__time-start">{{ _start.format('h:mm a') }}</span>
          <span v-if="end" class="event__time-end"> to {{ _end.format('h:mm a') }}</span>
        </p>
      </div>
      <div class="event__detail">
        <p v-if="leftDetail" class="event__detail_left">{{ leftDetail }}</p>
        <p v-if="rightDetail" class="event__detail_right">{{ rightDetail }}</p>
      </div>
      <div class="event__image-mobile">
        <Lightbox
          v-if="image"
          :thumb="thumbnail"
          :src="image"
        />
        <div v-if="!image" class="event__image-placeholder"></div>
      </div>
      <div class="event__description">
        <p v-for="(paragraph, index) in description.split('\n')" :key="index">{{ paragraph }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Lightbox from './Lightbox';

export default {
  name: 'Event',
  props: [
    'start',
    'end',
    'title',
    'location',
    'leftDetail',
    'rightDetail',
    'description',
    'image',
    'thumbnail',
  ],
  computed: {
    _start() { return moment(this.start); },
    _end() { return moment(this.end); }
  },
  components: {
    Lightbox
  }
}
</script>

<style lang="scss" scoped>
@import './event';
</style>
